import React, { useState, useEffect } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import { useNavigate } from "react-router-dom";
import URL from "../../../../constants/url";
import style from './HistoryCheck.module.css';


const HistoryCheck = () => {

    const navigate = useNavigate();

    //카카오 채널 이동 
    const handleOnJoinMeeting = (joinUrl) => {
        // React Native 에서 처리
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            // 일반 웹 브라우저
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    }

    return (
        <>
            <HeadSub title="가입 이력 확인" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-type="bottom-btns">

                    {/* 가입 이력 확인 컴퍼넌트 */}
                    <div className={style['component']}>
                        <strong className={style['title']}>
                            <b>카카오톡</b> 으로 <b>가입 이력</b>이 있습니다 <br />
                            아래 정보를 확인해주세요
                        </strong>

                        <div className={style['mid-box']}>
                            <p className={style['txt']}>고*정</p>
                            <p className={style['txt']}>
                                <span>tn****</span>@kakao.com
                            </p>
                            <div className={style['list-box']}>
                                <ul>
                                    <li>
                                        <p>서울성모병원</p>
                                        <span>10****84</span>
                                    </li>
                                    <li>
                                        <p>인천성모병원</p>
                                        <span>15****23</span>
                                    </li>
                                    <li>
                                        <p>대전성모병원</p>
                                        <span>25****35</span>
                                    </li>
                                </ul>
                            </div>
                            <div className={style['mid-bottom-box']}>
                                <p>위 계정으로 로그인 하시겠습니까?</p>
                                <span>구글 계정으로도 로그인 가능하도록 <br />
                                통합할 수 있어요</span>   
                            </div>
                        </div>        

                    </div>


                    {/* 잘못된 정보 표시 컴퍼넌트 */}
                    {/* <div className={style['component']}>
                        <strong className={style['title']}>
                            <b>잘못된 정보가 표시되고 있나요?</b> 
                        </strong>

                        <div className={style['mid-box']}>
                            <p className={style['txt-gray']}>표시된 정보가 회원님 본인 정보가 아니라면
                                고객센터로 연락 주세요.
                            </p>
                            <p className={style['txt-gray']}>계정 확인 및 수정 조치를 도와드리겠습니다.</p>
                            <div className={style['list-box']}>
                                <ul>
                                    <li>
                                        <p>고객센터</p>
                                        <span>02-2258-0000</span>
                                    </li>
                                    <li>
                                        <p>운영시간</p>
                                        <span>09:00~18:00</span>
                                    </li>
                                    <li>
                                        <p>이메일 문의</p>
                                        <span>help@dgtpharm.com</span>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div> */}

                    



                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box" data-height="auto">
                        <div className="inner-box">

                            <div className='btn-layout' data-btn-direction="column">

                                <button className={style["btn"]} data-login-btn="kao" >
                                    <span>카카오로 로그인하기</span>
                                </button>
                                <button className={style["btn"]} data-login-btn="google">
                                    <span>구글 계정 통합하기</span>
                                </button>
                                <button className={style["btn"]}>
                                    <span>내 정보가 아니에요</span>
                                </button>


                                {/* 잘못된 정보 표시 컴퍼넌트 */}
                                {/* <button className={style["btn"]} data-login-btn="kao" onClick={()=> handleOnJoinMeeting('https://pf.kakao.com/_xlvxeHn/chat')}>
                                    <span>카카오톡으로 문의하기</span>
                                </button>
                                <button className={style["btn"]}>
                                    <span>돌아가기</span>
                                </button> */}


                            </div>
                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}


                </div>
            </div>
            
        </>
    )
}

export default HistoryCheck